import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Link,
  Stack,
  useTheme,
} from '@mui/material';
import { useAnalytics } from '../contexts/AnalyticsContext';

const COOKIE_CONSENT_KEY = 'cookie_consent_given';
const MENU_WIDTH = 240; // Standard Material-UI drawer width

export const CookieConsent: React.FC = () => {
  const { trackEvent } = useAnalytics();
  const [showBanner, setShowBanner] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setShowBanner(false);
    trackEvent('cookie_consent', {
      action: 'accept'
    });
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'false');
    setShowBanner(false);
    trackEvent('cookie_consent', {
      action: 'decline'
    });
  };

  if (!showBanner) {
    return null;
  }

  return (
    <Paper
      elevation={3}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        p: 2,
        zIndex: 1000,
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        [theme.breakpoints.up('sm')]: {
          ml: `${MENU_WIDTH}px`,
          width: `calc(100% - ${MENU_WIDTH}px)`,
        },
      }}
    >
      <Stack spacing={2}>
        <Typography variant="body1">
          We use cookies and similar technologies to help personalize content, analyze traffic, and provide a better experience. 
          By clicking "Accept", you consent to our use of cookies for analytics purposes. 
          You can learn more about our{' '}
          <Link href="/privacy" color="primary">
            Privacy Policy
          </Link>
          {' '}and{' '}
          <Link href="/cookies" color="primary">
            Cookie Policy
          </Link>.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleDecline}
          >
            Decline
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAccept}
          >
            Accept
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
}; 